import { Navigate, Route, Routes } from "react-router-dom";
import JobPage from "./screens/JobPage";
import SplashScreen from "./screens/SplashScreen";
import Login from "./screens/Login/Login";
import ManageAddress from "./screens/ManageAddress/ManageAddress";
import LandingScreen from "./screens/LandingScreen/LandingScreen";
import Ratings from "./screens/Ratings";
import EditProfile from "./screens/EditProfile";
import Setting from "./screens/Setting";
import PrivateRoute from "./components/PrivateRoute";
import NewJobPage from "./screens/NewJobPage";
import InProgressJob from './screens/InProgressJob';
import JobDetailsFun from "./screens/jobQuotePage/JobDetailPage"; 
import CancelledAndRescheduledJobs from './screens/jobQuotePage/CancelledAndResheduledPage';
import ReschedulePageFun from "./screens/InProgressJob/RescheduleBS";
import PaidJobs from "./screens/paidJobs"; 
import PausedJobs from "./screens/pausedJobs"; 
import CompletedJobs from "./screens/completedJobs"; 
import TopQuotes from "./screens/topQuotes";
import InvoicePage from "./screens/viewInvoices";
import ViewInvoice from "./components/viewInvoice";
//import PauseOrPayJob from './screens/pauseorpayjob';
import CreatedJobs from './screens/createdJobs';
import PauseOrPayJob from './components/pauseOrPayJob';

export function AppRouter() {
  return (
    <Routes>
      {/* Default to Login */}
      <Route path="/" element={<Navigate replace to="/Login" />} />
      <Route path="/splash" element={<SplashScreen />} />
      <Route path="/Login" element={<Login />} />

      {/* Protect job routes so only logged-in users can access */}
      <Route element={<PrivateRoute />}>
        <Route path="/Job" element={<JobPage />} />
        <Route path="/ManageAddress" element={<ManageAddress />} />
        <Route path="/LandingScreen" element={<LandingScreen />} />
        <Route path="/ratings" element={<Ratings />} />
        <Route path="/editProfile" element={<EditProfile />} />
        <Route path="/setting" element={<Setting />} />
        <Route path="/newJob" element={<NewJobPage />} />
        <Route path="/InProgressJob" element={<InProgressJob />} />
        <Route path="/job-details/:jobId" element={<JobDetailsFun />} />
        <Route path="/CancelledAndRescheduledJobs" element={<CancelledAndRescheduledJobs />} />
        <Route path="/CancelledAndRescheduledJobs/:jobId" element={<CancelledAndRescheduledJobs />} />
        <Route path="/ReschedulePageFun/:jobId" element={<ReschedulePageFun />} />
        <Route path="/PaidJobs" element={<PaidJobs />} />
        <Route path="/PausedJobs" element={<PausedJobs />} />
        <Route path="/CompletedJobs" element={<CompletedJobs />} />
        <Route path="/TopQuotes" element={<TopQuotes />} />
        <Route path="/InvoicePage/:jobId" element={<InvoicePage />} />
        <Route path="/ViewInvoice/:jobId" element={<ViewInvoice />} />
        <Route path="/PauseOrPayJob" element={<PauseOrPayJob />} />
        <Route path="/CreatedJobs" element={<CreatedJobs />} />
        <Route path="/PauseOrPayJob/:jobId" element={<PauseOrPayJob />} />
   

      </Route>
    </Routes>
  );
}
